module.exports = __webpack_public_path__ + "img/date_white_24dp.fd1a3c35.png";